<template>
  <div class="bankProd_div01">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-cell-group class="item" v-for="prod in prodList" :key="prod.productId">
          <van-cell :border="false" center clickable :to="{name:'bankProdDetail',query:prod}">
            <template #icon>
              <img :src="getImg(prod.bank)">
            </template>
            <template #title>
              <span class="titleBig">{{prod.name}}</span>
              <span class="titleSmall">-{{prod.bankName}}</span>
            </template>
          </van-cell>
          <van-row type="flex" align="center" justify="center">
            <van-col span="10" offset="1">
              <div class="contentLeft1">{{prod.quota|tranNumber}}</div>
              <div class="contentLeft2">最高可贷额度(元)</div>
            </van-col>
            <van-col span="12">
              <span class="shuxian"></span>
              <span style="display: inline-block;">
                <div class="contentMid">利率浮动比例{{prod.limitScales}}</div>
                <div class="contentMid">利率{{prod.rate}}</div>
                <div class="contentMid">贷款期限{{prod.proLimit}}</div>
              </span>
            </van-col>
          </van-row>
          <div class="footer" v-if="haveTag(prod.productFeature)">
            <van-row type="flex">
              <van-col
                :span="getTagCount(prod.productFeature)"
                v-for="tag in getTagList(prod.productFeature)"
                :key="tag"
              >
                <van-cell :border="false" center>
                  <template #icon>
                    <van-icon name="passed" color="#108EE9" size=".26rem"/>
                  </template>
                  <template #title>
                    <span class="title">{{tag}}</span>
                  </template>
                </van-cell>
              </van-col>
            </van-row>
          </div>
        </van-cell-group>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      user: {},
      prodList: [],
      finished: false,
      loading: false,
      refreshing: false,
      pageNum: 0,
      isLastPage: false
    };
  },
  computed: {
    ...mapGetters(["sessionId", "userInfo", "userId"])
  },
  filters: {},
  async created() {
    let res = await this.$store.dispatch("user/getUserInfo");
    console.log(this.sessionId, res);
    console.log(this.sessionId, res);
    if (this.sessionId === "") {
      await this.checkAJB.userLogin();
      let res = await this.$store.dispatch("user/getUserInfo");
      console.log(this.sessionId, res);
      console.log(this.sessionId, res);
    }
    // this.getProList();
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        if (this.refreshing) {
          this.prodList = [];
          this.pageNum = 1;
          this.refreshing = false;
        }
        this.pageNum = this.pageNum + 1;
        this.getProList();
        if (!this.isLastPage) {
          //是否是最后一页 ture表示最后一页
          this.finished = true; //数据全部加载完成
        } else {
          this.loading = false;
          this.refreshing = false;
          console.log(this.loading, "hahhkhk");
        }
      }, 1000);
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    getProList() {
      var date = new Date(),
        time =
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1) +
          "-" +
          date.getDate(); //表示当前日期
      console.log(time, "lhc1111");
      var params = {
        data: {
          corpId: this.userId,
          sessionId: this.sessionId,
          pageNum: "1",
          pageSize: "50",
          startDate: "2020-04-01",
          endDate: time
        }
      };

      var host = "/sga";
      this.JSBridge.httpRequest({
        url: host + "/hjr/smartsocial/pms/SSHJRBPQ015",
        type: "post",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        data: params
      })
        .then(res => {
          console.log(res.data.paramPageInfo.list, 159684259);
          if (res.resCode == "0000") {
            for (var i = 0; i < res.data.paramPageInfo.list.length; i++) {
              var item = res.data.paramPageInfo.list[i];
              item.rate = this.formatPercent2(item.rate);
              item.limitScales = this.formatPercent2(item.limitScales);
              this.prodList.push(item);
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 百分比格式化函数
    formatPercent2(point) {
      if ((point + "").indexOf("%") > 0) return point;

      if (null == point) {
        return "--";
      }
      var percent = (point * 100).toFixed(2);
      percent += "%";
      return percent;
    },
    onClickLeft() {},
    onClickRight() {},
    getImg(bankCode) {
      var imgUrl;
      try {
        imgUrl = require("../../../assets/img/hjr_qyd_" +
          bankCode.trim().toLowerCase() +
          "_1.png");
      } catch (error) {
        console.log(imgUrl);
      }
      if (imgUrl == undefined) {
        return require("../../../assets/img/hjr_qyd_gh1.png");
      } else {
        return imgUrl;
      }
    },
    haveTag(productFeature) {
      console.log(productFeature);
      if (productFeature == undefined || productFeature == null) return false;
      if (productFeature.trim().length > 1) return true;
      else return false;
    },
    getTagCount(productFeature) {
      var count = productFeature.trim().split(",").length;
      if (count > 4) {
        return 6;
      } else {
        return 24 / count;
      }
    },
    getTagList(productFeature) {
      var tagList = productFeature.trim().split(",");
      while (tagList.length > 4) {
        tagList.pop();
      }
      return tagList;
    }
  }
};
</script>

<style lang="less" scoped>
.bankProd_div01 {
  background: rgba(241, 242, 243, 1);
  padding-top: 0.21rem;
  height: 100%;
  width: 100%;
  position: fixed;
  overflow-y: auto;
  .item {
    margin-bottom: 0.21rem;
    margin-left: 0.15rem;
    margin-right: 0.15rem;
    padding-top: 0.1rem;
    padding-bottom: 0.2rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.1rem;

    img {
      width: 0.5rem;
      height: 0.5rem;
    }

    .titleBig {
      display: inline-block;
      padding-left: 0.1rem;
      height: 0.37rem;
      font-size: 0.3rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 0.36rem;
    }

    .titleSmall {
      height: 0.3rem;
      font-size: 0.24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 0.3rem;
    }

    .contentLeft1 {
      height: 0.62rem;
      font-size: 0.44rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 167, 22, 1);
      line-height: 0.62rem;
    }

    .contentLeft2 {
      height: 0.33rem;
      font-size: 0.24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 0.33rem;
    }

    .shuxian {
      display: inline-block;
      margin-right: 0.2rem;
      width: 0.01rem;
      height: 0.84rem;
      background: rgba(216, 216, 216, 1);
    }

    .contentMid {
      height: 0.33rem;
      font-size: 0.24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 0.4;
      color: rgba(153, 153, 153, 1);
      line-height: 0.33rem;
    }

    .van-button--normal {
      padding: 0 0.1rem;
    }

    .apply {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 0.3rem;
      font-size: 0.22rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(16, 142, 233, 1);
      line-height: 0.3rem;
    }

    .footer {
      margin-top: 0.15rem;
      margin-left: 0.15rem;
      margin-right: 0.15rem;
      padding-top: 0.1rem;
      border-top-width: 0.02rem;
      border-top-style: solid;
      border-top-color: #f1f2f3;

      .title {
        height: 0.28rem;
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 0.28rem;
      }
    }
  }
}
</style>
